module.exports = __webpack_public_path__ + "img/plant-fuel.1c0311c5.png";